import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from 'react-router-dom';
import DOMPurify from "dompurify";

const FaqHome = () => {
    const backendBaseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [faqs, setFaqs] = useState([]);

    useEffect(() => {
        const fetchFaqs = async () => {
            const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
            const Url = process.env.REACT_APP_API_FAQ_HOME;

            const cachedFaqs = localStorage.getItem("faqsHome");
            const cacheTimestamp = localStorage.getItem("faqsHomeTimestamp");
            const cacheExpiryTime = 30 * 60 * 1000; // 30 minutes

            if (cachedFaqs && cacheTimestamp && (Date.now() - cacheTimestamp < cacheExpiryTime)) {
                setFaqs(JSON.parse(cachedFaqs));
            } else {
                try {
                    const response = await axios.get(`${apiBaseUrl}${Url}`);
                    setFaqs(response.data);
                    localStorage.setItem("faqsHome", JSON.stringify(response.data));
                    localStorage.setItem("faqsHomeTimestamp", Date.now());
                } catch (error) {
                    console.error('Failed to fetch FAQs:', error);
                }
            }
        };

        fetchFaqs();
    }, []);

    return (
        <section className="faq-area pt-80 pb-80" style={{ backgroundColor: '#f8fafc' }}>
            <div className="container px-1">
                {/* Modern Section Header */}
                <div className="row justify-content-center mb-5">
                    <div className="col-lg-8 text-center">
                        <span className="text-primary fw-bold text-uppercase" style={{ letterSpacing: '2px', fontSize: '0.9rem' }}>
                            Got Questions?
                        </span>
                        <h2 className="display-6 fw-bold text-dark mt-2 mb-3">Frequently Asked Questions</h2>
                        <div className="bg-primary mx-auto" style={{ width: '60px', height: '3px', borderRadius: '2px' }}></div>
                    </div>
                </div>

                <div className="row align-items-center g-5">
                    {/* Left Side: Image & Call to Action */}
                    <div className="col-lg-5">
                        <div className="faq-content text-center text-lg-start">
                            <div className="mb-4 overflow-hidden rounded-4 shadow-sm bg-white p-3 border">
                                <img
                                    src="/assets/img/faq.webp"
                                    alt="FAQ Illustration"
                                    className="img-fluid rounded-3 w-100"
                                    style={{ maxHeight: '350px', objectFit: 'cover' }}
                                    onError={(e) => {
                                        e.target.src = "https://i.ibb.co/3W83s0m/globe-logo-placeholder.png";
                                    }}
                                />
                            </div>
                            <h4 className="fw-bold text-dark mb-3">Have any other questions?</h4>
                            <p className="text-muted mb-4 small">
                                Feel free to reach out to our expert support team for quick assistance regarding your overseas career.
                            </p>
                            <Link
                                className="btn btn-primary px-4 py-3 rounded-pill text-uppercase fw-bold text-decoration-none shadow-sm"
                                to={'/contact-us'}
                            >
                                Contact Us <i className="fa fa-arrow-right ms-2"></i>
                            </Link>
                        </div>
                    </div>

                    {/* Right Side: Accordion */}
                    <div className="col-lg-7">
                        <div className="accordion custom-accordion" id="accordionExample-1">
                            {faqs?.map((faq, index) => {
                                const isOpen = index === 0;
                                return (
                                    <div
                                        className="accordion-item mb-3 border-0 shadow-sm rounded-4 overflow-hidden bg-white"
                                        key={index}
                                    >
                                        <h2 className="accordion-header" id={`heading${index}`}>
                                            <button
                                                className={`accordion-button fw-bold py-3 px-4 ${isOpen ? '' : 'collapsed'}`}
                                                type="button"
                                                data-bs-toggle="collapse"
                                                data-bs-target={`#collapse${index}`}
                                                aria-expanded={isOpen}
                                                aria-controls={`collapse${index}`}
                                                style={{
                                                    backgroundColor: isOpen ? '#e0f2fe' : '#ffffff',
                                                    color: '#0f172a',
                                                    boxShadow: 'none'
                                                }}
                                            >
                                                {faq?.question}
                                            </button>
                                        </h2>
                                        <div
                                            id={`collapse${index}`}
                                            className={`accordion-collapse collapse ${isOpen ? 'show' : ''}`}
                                            aria-labelledby={`heading${index}`}
                                            data-bs-parent="#accordionExample-1"
                                        >
                                            <div className="accordion-body px-4 py-3 text-muted" style={{ lineHeight: '1.7' }}>
                                                <div
                                                    dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(faq?.answer) }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                        {/* Know More Button */}
                        <div className="country-wrap text-center mt-4">
                            <Link className={'btn btn-outline-primary px-4 py-2 rounded-pill fw-bold text-uppercase'} to={'/faqs'}>
                                Know More <i className="fa fa-plus ms-1"></i>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FaqHome;